module.exports = __webpack_public_path__ + "static/img/17年泰州蜂鸟 二等奖.88c3617a.jpg";